import { useLang } from 'hooks/lang';

import { TaskSampleId } from 'entities';

import { Tag, Row, Column, Tooltip } from 'components/Blocks';
import { ZeroDataIcon } from 'components/Icons';

interface SampleIdsDisplayProps {
  ids: TaskSampleId[];
}

export function SampleIdsDisplay({ ids }: SampleIdsDisplayProps) {
  const { t } = useLang();

  if (!ids.length)
    return (
      <Column gap="2" alignItems="center">
        <ZeroDataIcon />
        <p>{t('no-ids-found')}</p>
      </Column>
    );

  return (
    <Row flexWrap="wrap">
      {ids.map((id) => (
        <Tooltip content={`OW Associated: ${id.owId}`} key={id.owId} ensurePresence>
          <Tag key={id.owId} name={id.owId} color="primary" size="medium" className="min-w-9" />
        </Tooltip>
      ))}
    </Row>
  );
}
